import './index.scss'

function Loader() {
  return (
    <div className='loaderContainer' >
      <span className='loader'>Loading</span>
    </div>
  )
}

export default Loader